function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#343333",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.667 13.333A2.668 2.668 0 007 16c0 .984.54 1.835 1.333 2.298v8.738A2.656 2.656 0 007 29.333 2.668 2.668 0 009.667 32a2.668 2.668 0 002.666-2.667c0-.984-.538-1.834-1.333-2.297v-8.738A2.656 2.656 0 0012.333 16a2.668 2.668 0 00-2.666-2.667zm0 17.334a1.333 1.333 0 110-2.667 1.333 1.333 0 010 2.667zm0-13.334a1.333 1.333 0 11-.001-2.666 1.333 1.333 0 010 2.666zm13 9.703v-8.37c0-4.01-4-4-4-4h-1.334V12l-4 4 4 4v-2.667h1.334c1.175 0 1.333 1.334 1.333 1.334v8.37a2.653 2.653 0 00-1.333 2.296A2.668 2.668 0 0021.333 32 2.668 2.668 0 0024 29.333c0-.984-.54-1.834-1.333-2.297zm-1.334 3.63a1.333 1.333 0 110-2.666 1.333 1.333 0 010 2.667z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#898989",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgGithubPr = function SvgGithubPr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithubPr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/github_pr.257a8ccf.svg";
export { ForwardRef as ReactComponent };